import metrics from './metrics';

const mobile = `${metrics.mobile}px`;

const getDesktopFont = ({
  fontSize, lineHeight, letterSpacing, fontWeight,
}) => `
  font-family: ${fontWeight ? 'NeueHaasUnicaPro-Bold' : 'NeueHaasUnicaPro-Regular'};
  font-size: ${fontSize || 31}px;
  line-height: ${lineHeight || 1};
  letter-spacing: ${letterSpacing || 'normal'};
  font-weight: normal;
`;

const getMobileFont = ({
  fontSize, lineHeight, letterSpacing, fontWeight,
}) => `
  @media (max-width: ${mobile}) {
    font-family: ${fontWeight ? 'NeueHaasUnicaPro-Bold' : 'NeueHaasUnicaPro-Regular'};
    font-size: ${fontSize || 31}px;
    line-height: ${lineHeight || 1};
    letter-spacing: ${letterSpacing || 'normal'};
    font-weight: normal;
  }
`;

export default {
  getTitle: (bold) => `
    ${getDesktopFont({ fontSize: 53, lineHeight: 1.17 })}
    ${getMobileFont({ lineHeight: 1.45, fontWeight: bold && 500 })}
  `,
  getSubTitle: (bold) => `
    ${getDesktopFont({ lineHeight: 1.26 })}
    ${getMobileFont({
    fontSize: 21, lineHeight: 1.29, fontWeight: bold && 500,
  })}
  `,
  getRegularText: (bold) => `
    ${getDesktopFont({ fontSize: 19, lineHeight: 1.37, fontWeight: bold && 'bold' })}
    ${getMobileFont({
    fontSize: 16.5, lineHeight: 1.33, letterSpacing: '0.59px', fontWeight: bold && 'bold',
  })}
  `,
  getSmallText: (bold) => `
    ${getDesktopFont({ fontSize: 14, lineHeight: 1.36, letterSpacing: '0.5px' })}
    ${getMobileFont({
    fontSize: 14, lineHeight: 1.36, letterSpacing: '0.5px', fontWeight: bold && 'bold',
  })}
  `,
  getDesktopFont,
  getMobileFont,
};
